<template>
  <Home id="app"/>
</template>

<script>
import Home from './components/Home.vue'

export default {
  components: {Home}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?619b9ae4